"use client";

import { useState, useEffect } from "react";
import { AnimatedCircularProgressBar } from "../ui/animated-circular-progress-bar";

interface AnimatedCircularProgressProps {
    duration?: number;
    onComplete?: () => void;
}

export function AnimatedCircularProgress({ duration = 120, onComplete }: AnimatedCircularProgressProps) {
    const [progress, setProgress] = useState(100);
    const intervalTime = (duration / 100) * 1000;

    useEffect(() => {
        const interval = setInterval(() => {
            setProgress((prev) => Math.max(prev - 1, 0));
        }, intervalTime);

        return () => clearInterval(interval);
    }, []);

    useEffect(() => {
        if (progress === 0 && onComplete) {
            onComplete();
        }
    }, [progress, onComplete]);

    return (
        <AnimatedCircularProgressBar
            className="w-10 h-10 text-[12px] pb-1"
            max={100}
            min={0}
            value={progress}
            gaugePrimaryColor="rgb(79 70 229)"
            gaugeSecondaryColor="rgba(229, 229, 229, 0.1)"
        />
    );
}
